import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

/** Passed via location.state to reset drill-in views on the same route. */
export const NAV_RESET_EVENT_GROUPS = 'resetEventGroups';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isOnPath = (path) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname === '';
    }
    return location.pathname === path;
  };

  /** Re-clicking Home/Events while already there should return to the list view. */
  const handleSameRouteNav = (path, event) => {
    if (!isOnPath(path)) return;
    event.preventDefault();
    navigate(path, {
      replace: true,
      state: { [NAV_RESET_EVENT_GROUPS]: Date.now() }
    });
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="Swim With a Splash Logo" className="logo-image" />
          <h1>Swim With a Splash</h1>
        </Link>
        <nav className="nav">
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={(e) => handleSameRouteNav('/', e)}
          >
            Home
          </Link>
          <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>
            About
          </Link>
          <Link to="/team" className={`nav-link ${isActive('/team') ? 'active' : ''}`}>
            Team
          </Link>
          <Link
            to="/events"
            className={`nav-link ${isActive('/events') ? 'active' : ''}`}
            onClick={(e) => handleSameRouteNav('/events', e)}
          >
            Events
          </Link>
          <Link to="/feedback" className={`nav-link ${isActive('/feedback') ? 'active' : ''}`}>
            Feedback
          </Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>
            Contact
          </Link>
          
          
        </nav>
      </div>
    </header>
  );
};

export default Header; 